import React, { useState, useRef, useEffect, useCallback, useContext } from 'react'
import { useNavigate, Link, useParams } from 'react-router-dom'
import axios from '../../../../../config/axios'
import UserContext from '../../../../../contexts/UserContext'
import plus from '../../../../../assets/certificates/AddParameter/blue-plus.svg'
import save from '../../../../../assets/certificates/AddParameter/save.svg'
import trash from '../../../../../assets/equipment/Tables/trash.svg'
import rectangle from '../../../../../assets/equipment/rectangle.svg'
import {
  MainContainer,
  StyledCard,
  StyledCardHeader,
  FormGrid,
  StyledFormGroup,
  MaintenanceServiceWrapper,
  ToggleSwitchContainer,
  SwitchLabel,
  Slider,
  SwitchInput,
  AddMaintenanceButton,
  StyledMaintenanceItem,
  VerificationGroup,
  PeriodicidadeGroup,
  DeleteButton,
  ActionButtons,
  CancelButton,
  SaveButton,
  SubHeaderContainer,
  SectionName,
  LeftSide,
  BreadcrumbsContainer,
  CardTitle,
  ToggleSwitchLabelText,
  NameGroup,
  DropdownContainer,
  DropdownHeader,
  DropdownHeaderSelectedItems,
  DropdownSelectedItemTag,
  DropdownList,
  DropdownListItem,
} from '../RegisterEquipment/style'
import CompanySelect from '../../Select/CompanySelect'
import UserSelect from '../../Select/UserSelect'

interface CompanyItemType {
  id: number
  companyName: string
}

interface UserItemType {
  id: number
  name: string
}

type ServiceProviderType = UserItemType | CompanyItemType | null

interface MaintenanceScheduleItem {
  id: number
  maintenanceName: string
  periodicityValue: string
  periodicityUnit: '' | 'dias' | 'semanas' | 'meses' | 'anos'
  isVerificationEnabled: boolean
  verificationValue: string
  verificationUnit: '' | 'dias' | 'semanas' | 'meses' | 'anos'
  isInternalService: boolean
  selectedServiceProvider: ServiceProviderType
}

interface FormState {
  code: string
  name: string
  model: string
  manufacturer: string
  year: string
  type: string
  dimension: string
  weight: string
  location: string
  costPerHour: string
  capacity: string
  selectedServiceProviders: UserItemType[]
}

const Breadcrumbs: React.FC<{ items: { label: string; path?: string }[] }> = ({
  items,
}) => (
  <BreadcrumbsContainer>
    <ol>
      {items.map((item, index) => (
        <li key={index}>
          {index === items.length - 1 ? (
            <span>{item.label}</span>
          ) : item.path ? (
            <Link to={item.path}>{item.label}</Link>
          ) : (
            <span>{item.label}</span>
          )}
        </li>
      ))}
    </ol>
  </BreadcrumbsContainer>
)

const MaintenanceItemFields: React.FC<{
  item: MaintenanceScheduleItem
  onMaintenanceChange: {
    (
      id: number,
      field: 'isVerificationEnabled' | 'isInternalService',
      value: boolean,
    ): void
    (
      id: number,
      field: 'selectedServiceProvider',
      value: ServiceProviderType,
    ): void
    (
      id: number,
      field:
        | 'periodicityValue'
        | 'periodicityUnit'
        | 'verificationValue'
        | 'verificationUnit'
        | 'maintenanceName',
      value: string,
    ): void
  }
  onRemove: (id: number) => void
}> = ({ item, onMaintenanceChange, onRemove }) => {
  return (
    <StyledMaintenanceItem>
      <NameGroup>
        <label htmlFor={`maintenance-name-${item.id}`}>Nome</label>
        <input
          type='text'
          id={`maintenance-name-${item.id}`}
          value={item.maintenanceName}
          onChange={(e) =>
            onMaintenanceChange(item.id, 'maintenanceName', e.target.value)
          }
          placeholder='Digite aqui'
        />
      </NameGroup>

      <PeriodicidadeGroup>
        <label htmlFor={`periodicity-value-${item.id}`}>Periodicidade</label>
        <div className='input-wrapper'>
          <span className='prefix-text'>A cada</span>
          <input
            type='text'
            id={`periodicity-value-${item.id}`}
            value={item.periodicityValue}
            onChange={(e) =>
              onMaintenanceChange(item.id, 'periodicityValue', e.target.value)
            }
            placeholder='Digite aqui'
          />
          <select
            id={`periodicity-unit-${item.id}`}
            value={item.periodicityUnit}
            onChange={(e) =>
              onMaintenanceChange(
                item.id,
                'periodicityUnit',
                e.target.value as MaintenanceScheduleItem['periodicityUnit'],
              )
            }
          >
            <option value=''>Selecione</option>
            <option value='dias'>Dias</option>
            <option value='semanas'>Semanas</option>
            <option value='meses'>Meses</option>
            <option value='anos'>Anos</option>
          </select>
        </div>
      </PeriodicidadeGroup>

      <img
        src={rectangle}
        alt='Separador'
        style={{
          alignSelf: 'center',
          height: '100%',
          width: '1px',
          backgroundColor: '#E0E0E0',
          justifySelf: 'center',
        }}
      />

      <VerificationGroup>
        <label htmlFor={`verification-toggle-${item.id}`}>Verificação</label>
        <div className='toggle-content-wrapper'>
          <ToggleSwitchContainer>
            <SwitchLabel
              htmlFor={`verification-toggle-${item.id}`}
              className='verification-switch-align'
            >
              <SwitchInput
                type='checkbox'
                id={`verification-toggle-${item.id}`}
                checked={item.isVerificationEnabled}
                onChange={(e) =>
                  onMaintenanceChange(
                    item.id,
                    'isVerificationEnabled',
                    e.target.checked,
                  )
                }
              />
              <Slider className='slider' />
            </SwitchLabel>
          </ToggleSwitchContainer>

          <div className='verification-fields'>
            <span className='prefix-text'>A cada</span>
            <input
              type='text'
              id={`verification-value-${item.id}`}
              value={item.verificationValue}
              onChange={(e) =>
                onMaintenanceChange(
                  item.id,
                  'verificationValue',
                  e.target.value,
                )
              }
              disabled={!item.isVerificationEnabled}
              placeholder='Digite aqui'
            />
            <select
              id={`verification-unit-${item.id}`}
              value={item.verificationUnit}
              onChange={(e) =>
                onMaintenanceChange(
                  item.id,
                  'verificationUnit',
                  e.target.value as MaintenanceScheduleItem['verificationUnit'],
                )
              }
              disabled={!item.isVerificationEnabled}
            >
              <option value=''>Selecione</option>
              <option value='dias'>Dias</option>
              <option value='semanas'>Semanas</option>
              <option value='meses'>Meses</option>
              <option value='anos'>Anos</option>
            </select>
          </div>
        </div>
      </VerificationGroup>

      <DeleteButton type='button' onClick={() => onRemove(item.id)}>
        <img src={trash} alt='Excluir' />
      </DeleteButton>

      <MaintenanceServiceWrapper>
        <ToggleSwitchContainer>
          <ToggleSwitchLabelText>Interno</ToggleSwitchLabelText>
          <SwitchLabel
            htmlFor={`item-isInternalService-${item.id}`}
            className='internal-switch-align'
          >
            <SwitchInput
              type='checkbox'
              id={`item-isInternalService-${item.id}`}
              name={`item-isInternalService-${item.id}`}
              checked={item.isInternalService}
              onChange={(e) => {
                onMaintenanceChange(
                  item.id,
                  'isInternalService',
                  e.target.checked,
                )
                onMaintenanceChange(item.id, 'selectedServiceProvider', null)
              }}
            />
            <Slider className='slider' />
          </SwitchLabel>
        </ToggleSwitchContainer>

        <StyledFormGroup className='flex-grow'>
          {item.isInternalService ? (
            <UserSelect<UserItemType>
              label='Responsável'
              apiUrl={`${process.env.REACT_APP_GATEWAY_BASE_URL}/backend/user/findAll`}
              displayField='name'
              value={item.selectedServiceProvider as UserItemType}
              onChange={(user) =>
                onMaintenanceChange(item.id, 'selectedServiceProvider', user)
              }
              permission="production"
            />
          ) : (
            <CompanySelect<CompanyItemType | null>
              label='Responsável'
              apiUrl={`${process.env.REACT_APP_GATEWAY_BASE_URL}/companies/companies`}
              displayField='companyName'
              queryParams={{ companyType: 2 }}
              value={item.selectedServiceProvider as CompanyItemType | null}
              onChange={(company) =>
                onMaintenanceChange(item.id, 'selectedServiceProvider', company)
              }
            />
          )}
        </StyledFormGroup>
      </MaintenanceServiceWrapper>
    </StyledMaintenanceItem>
  )
}

const EditMachine = () => {
  const navigate = useNavigate()
  const { id } = useParams<{ id: string }>()
  const { user } = useContext(UserContext)
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState<string | null>(null)

  const [form, setForm] = useState<FormState>({
    code: '',
    name: '',
    model: '',
    manufacturer: '',
    year: '',
    type: '',
    dimension: '',
    weight: '',
    location: '',
    costPerHour: '',
    capacity: '',
    selectedServiceProviders: [],
  })

  const [userSelectKey, setUserSelectKey] = useState(0)

  const [maintenanceSchedule, setMaintenanceSchedule] = useState<
    MaintenanceScheduleItem[]
  >([])

  const fetchServiceProviderData = useCallback(async (
    providerId: number, 
    isInternal: boolean
  ): Promise<ServiceProviderType> => {
    const token = localStorage.getItem('token')
    
    try {
      if (isInternal) {
        const response = await axios.get(
          `${process.env.REACT_APP_GATEWAY_BASE_URL}/backend/user/${providerId}`
        )
        
        const userData = response.data
        if (userData?.id && userData?.name) {
          return { id: userData.id, name: userData.name }
        }
      } else {
        const response = await axios.get(
          `${process.env.REACT_APP_GATEWAY_BASE_URL}/companies/companies/${providerId}`,
          { headers: { Authorization: `Bearer ${token}` } }
        )
        
        const companyData = response.data
        if (companyData?.id && companyData?.companyName) {
          return { id: companyData.id, companyName: companyData.companyName }
        }
      }
    } catch (error) {
      console.error(`Erro ao buscar prestador ${providerId} (interno: ${isInternal}):`, error)
    }
    
    return null
  }, [])

  useEffect(() => {
    const fetchMachineData = async () => {
      if (!id) {
        setError('ID da máquina não fornecido.')
        setLoading(false)
        return
      }

      try {
        setLoading(true)
        const token = localStorage.getItem('token')
        
        if (!token) {
          setError('Token de autenticação não encontrado.')
          return
        }

        const response = await axios.get(
          `${process.env.REACT_APP_GATEWAY_BASE_URL}/equipment/equipment/${id}`,
          { headers: { Authorization: `Bearer ${token}` } }
        )
        
        const machineData = response.data

        const selectedServiceProviders: UserItemType[] = []
        if (machineData.selectedServiceProviders?.length > 0) {
          for (const provider of machineData.selectedServiceProviders) {
            if (provider?.id && provider?.name) {
              selectedServiceProviders.push({
                id: provider.id,
                name: provider.name
              })
            }
          }
        }

        setForm({
          code: machineData.code || '',
          name: machineData.name || '',
          model: machineData.model || '',
          manufacturer: machineData.manufacturer || '',
          year: machineData.year ? String(machineData.year) : '',
          type: machineData.type || '',
          dimension: machineData.dimension || '',
          weight: machineData.weight ? String(machineData.weight) : '',
          location: machineData.location || '',
          costPerHour: machineData.costPerHour ? String(machineData.costPerHour) : '',
          capacity: machineData.capacity || '',
          selectedServiceProviders
        })

        const processedMaintenances: MaintenanceScheduleItem[] = []
        
        if (machineData.periodicMaintenances?.length > 0) {
          const maintenancePromises = machineData.periodicMaintenances.map(
            async (maintenance: any, index: number) => {
              
              let selectedServiceProvider: ServiceProviderType = null
              
              if (maintenance.isInternalService) {
                if (maintenance.serviceProviderUser?.id && maintenance.serviceProviderUser?.name) {
                  selectedServiceProvider = {
                    id: maintenance.serviceProviderUser.id,
                    name: maintenance.serviceProviderUser.name
                  }
                } else if (maintenance.serviceProviderUserId) {
                  selectedServiceProvider = await fetchServiceProviderData(
                    maintenance.serviceProviderUserId, 
                    true
                  )
                }
              } else {
                if (maintenance.serviceProviderCompany?.id && maintenance.serviceProviderCompany?.companyName) {
                  selectedServiceProvider = {
                    id: maintenance.serviceProviderCompany.id,
                    companyName: maintenance.serviceProviderCompany.companyName
                  }
                } else if (maintenance.serviceProviderCompanyId) {
                  selectedServiceProvider = await fetchServiceProviderData(
                    maintenance.serviceProviderCompanyId, 
                    false
                  )
                }
              }

              return {
                id: index + 1,
                maintenanceName: maintenance.maintenanceName || '',
                periodicityValue: maintenance.periodicityValue ? String(maintenance.periodicityValue) : '',
                periodicityUnit: maintenance.periodicityUnit || '',
                isVerificationEnabled: Boolean(maintenance.isVerificationEnabled),
                verificationValue: maintenance.verificationValue ? String(maintenance.verificationValue) : '',
                verificationUnit: maintenance.verificationUnit || '',
                isInternalService: Boolean(maintenance.isInternalService),
                selectedServiceProvider
              }
            }
          )

          const resolvedMaintenances = await Promise.all(maintenancePromises)
          processedMaintenances.push(...resolvedMaintenances)
        }

        if (processedMaintenances.length === 0) {
          processedMaintenances.push({
            id: 1,
            maintenanceName: '',
            periodicityValue: '',
            periodicityUnit: '',
            isVerificationEnabled: false,
            verificationValue: '',
            verificationUnit: '',
            isInternalService: false,
            selectedServiceProvider: null,
          })
        }

        setMaintenanceSchedule(processedMaintenances)

      } catch (err) {
        console.error('Erro ao carregar dados da máquina:', err)
        setError('Erro ao carregar os dados da máquina.')
      } finally {
        setLoading(false)
      }
    }

    fetchMachineData()
  }, [id, fetchServiceProviderData])

  const handleChange = (
    e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>,
  ) => {
    const { name, value } = e.target
    setForm((prev) => ({ ...prev, [name]: value }))
  }

  const handleMaintenanceChange = (
    id: number,
    field: keyof MaintenanceScheduleItem,
    value: any,
  ) => {
    setMaintenanceSchedule((prev) =>
      prev.map((item) => {
        if (item.id === id) {
          if (field === 'isVerificationEnabled') {
            return {
              ...item,
              isVerificationEnabled: value as boolean,
              ...(value === false && {
                verificationValue: '',
                verificationUnit: '',
              }),
            }
          }
          if (field === 'isInternalService') {
            return {
              ...item,
              isInternalService: value as boolean,
              selectedServiceProvider: null,
            }
          }
          if (field === 'selectedServiceProvider') {
            return {
              ...item,
              selectedServiceProvider: value as ServiceProviderType,
            }
          }
          return { ...item, [field]: value }
        }
        return item
      }),
    )
  }

  const handleAddServiceProvider = (provider: UserItemType | null) => {
    if (provider) {
      setForm((prev) => {
        if (!prev.selectedServiceProviders.some((p) => p.id === provider.id)) {
          return {
            ...prev,
            selectedServiceProviders: [
              ...prev.selectedServiceProviders,
              provider,
            ],
          }
        }
        return prev
      })
      setUserSelectKey((prevKey) => prevKey + 1)
    }
  }

  const handleRemoveServiceProvider = (providerId: number) => {
    setForm((prev) => ({
      ...prev,
      selectedServiceProviders: prev.selectedServiceProviders.filter(
        (provider) => provider.id !== providerId,
      ),
    }))
  }

  const addMaintenanceItem = () => {
    setMaintenanceSchedule((prev) => [
      ...prev,
      {
        id: prev.length > 0 ? Math.max(...prev.map((i) => i.id)) + 1 : 1,
        maintenanceName: '',
        periodicityValue: '',
        periodicityUnit: '',
        isVerificationEnabled: false,
        verificationValue: '',
        verificationUnit: '',
        isInternalService: false,
        selectedServiceProvider: null,
      },
    ])
  }

  const removeMaintenanceItem = (id: number) => {
    setMaintenanceSchedule((prev) => prev.filter((item) => item.id !== id))
  }

  const validateForm = (): string | null => {
    // Validação dos campos obrigatórios básicos
    if (!form.year || !form.year.trim()) {
      return 'O campo "Ano" é obrigatório.'
    }
    if (isNaN(parseInt(form.year))) {
      return 'O campo "Ano" deve ser um número válido.'
    }
    if (!form.weight || !form.weight.trim()) {
      return 'O campo "Peso" é obrigatório.'
    }
    if (isNaN(parseFloat(form.weight))) {
      return 'O campo "Peso" deve ser um número válido.'
    }
    if (!form.costPerHour || !form.costPerHour.trim()) {
      return 'O campo "Custo/Hora" é obrigatório.'
    }
    if (isNaN(parseFloat(form.costPerHour))) {
      return 'O campo "Custo/Hora" deve ser um número válido.'
    }

    if (form.selectedServiceProviders.length === 0) {
      return 'O campo "Prestador de Serviço" é obrigatório.'
    }

    for (const item of maintenanceSchedule) {
      if (!item.maintenanceName.trim()) {
        return 'O nome da manutenção periódica não pode ser vazio.'
      }
      
      if (!item.periodicityValue || isNaN(parseFloat(item.periodicityValue))) {
        return `O valor da periodicidade para "${item.maintenanceName}" é obrigatório e deve ser um número válido.`
      }
      
      if (!item.periodicityUnit) {
        return `A unidade de periodicidade para "${item.maintenanceName}" é obrigatória.`
      }
      
      if (item.isVerificationEnabled) {
        if (!item.verificationValue || isNaN(parseFloat(item.verificationValue))) {
          return `O valor da verificação para "${item.maintenanceName}" é obrigatório e deve ser um número válido.`
        }
        if (!item.verificationUnit) {
          return `A unidade de verificação para "${item.maintenanceName}" é obrigatória.`
        }
      }
      
      if (!item.selectedServiceProvider) {
        return `O campo 'Responsável' é obrigatório para a manutenção "${item.maintenanceName}".`
      }
    }

    return null
  }

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault()
    
    const token = localStorage.getItem('token')
    if (!token) {
      alert('Sessão expirada ou não logado. Faça login novamente.')
      return
    }

    const validationError = validateForm()
    if (validationError) {
      alert(validationError)
      return
    }

    const dataToSend = {
      ...form,
      year: parseInt(form.year),
      weight: parseFloat(form.weight),
      costPerHour: parseFloat(form.costPerHour),
      selectedServiceProviders: form.selectedServiceProviders.map((p) => String(p.id)),
      maintenanceSchedule: maintenanceSchedule.map((item) => ({
        maintenanceName: item.maintenanceName.trim(),
        periodicityValue: parseFloat(item.periodicityValue),
        periodicityUnit: item.periodicityUnit,
        isVerificationEnabled: item.isVerificationEnabled,
        ...(item.isVerificationEnabled && {
          verificationValue: parseFloat(item.verificationValue),
          verificationUnit: item.verificationUnit,
        }),
        isInternalService: item.isInternalService,
        selectedServiceProviders: item.selectedServiceProvider 
          ? [String(item.selectedServiceProvider.id)] 
          : [],
      })),
    }

    try {
      await axios.put(
        `${process.env.REACT_APP_GATEWAY_BASE_URL}/equipment/equipment/${id}`,
        dataToSend,
        {
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${token}`,
          },
        },
      )
      alert('Máquina atualizada com sucesso!')
      navigate('/panel/equipment')
    } catch (error) {
      console.error('Erro ao atualizar máquina:', error)
      const errorMessage = axios.isAxiosError(error)
        ? error.response?.data?.message || error.message
        : 'Erro na requisição'
      alert(`Erro ao atualizar máquina: ${errorMessage}`)
    }
  }

  const breadcrumbItems = [
    { label: 'Equipamentos', path: '/panel/equipment' },
    { label: 'Editar máquina' },
  ]

  if (loading) {
    return (
      <MainContainer>
        <div style={{ textAlign: 'center', padding: '2rem' }}>
          Carregando dados da máquina...
        </div>
      </MainContainer>
    )
  }

  if (error) {
    return (
      <MainContainer>
        <div style={{ textAlign: 'center', padding: '2rem', color: 'red' }}>
          <h3>Erro</h3>
          <p>{error}</p>
          <button onClick={() => navigate('/panel/equipment')}>
            Voltar para Equipamentos
          </button>
        </div>
      </MainContainer>
    )
  }

  return (
    <>
      <SubHeaderContainer>
        <LeftSide>
          <SectionName>Editar máquina</SectionName>
        </LeftSide>
      </SubHeaderContainer>

      <Breadcrumbs items={breadcrumbItems} />

      <MainContainer>
        <form onSubmit={handleSubmit}>
          <StyledCard>
            <CardTitle>Identificação</CardTitle>
            <FormGrid cols={3}>
              <StyledFormGroup>
                <label htmlFor='code'>Código</label>
                <input
                  type='text'
                  id='code'
                  name='code'
                  value={form.code}
                  onChange={handleChange}
                  placeholder='Digite aqui'
                />
              </StyledFormGroup>
              <StyledFormGroup>
                <label htmlFor='name'>Nome</label>
                <input
                  type='text'
                  id='name'
                  name='name'
                  value={form.name}
                  onChange={handleChange}
                  placeholder='Digite aqui'
                />
              </StyledFormGroup>
              <StyledFormGroup>
                <label htmlFor='model'>Modelo</label>
                <input
                  type='text'
                  id='model'
                  name='model'
                  value={form.model}
                  onChange={handleChange}
                  placeholder='Digite aqui'
                />
              </StyledFormGroup>
              <StyledFormGroup>
                <label htmlFor='manufacturer'>Fabricante</label>
                <input
                  type='text'
                  id='manufacturer'
                  name='manufacturer'
                  value={form.manufacturer}
                  onChange={handleChange}
                  placeholder='Digite aqui'
                />
              </StyledFormGroup>
              <StyledFormGroup>
                <label htmlFor='year'>Ano</label>
                <input
                  type='number'
                  id='year'
                  name='year'
                  value={form.year}
                  onChange={handleChange}
                  placeholder='Digite aqui'
                  min='1900'
                  max='2100'
                />
              </StyledFormGroup>
              <StyledFormGroup>
                <label htmlFor='type'>Tipo</label>
                <select
                  id='type'
                  name='type'
                  value={form.type}
                  onChange={handleChange}
                >
                  <option value=''>Selecione</option>
                  <option value='tipo1'>Tipo 1</option>
                  <option value='tipo2'>Tipo 2</option>
                </select>
              </StyledFormGroup>
              <StyledFormGroup>
                <label htmlFor='dimension'>Dimensão</label>
                <input
                  type='text'
                  id='dimension'
                  name='dimension'
                  value={form.dimension}
                  onChange={handleChange}
                  placeholder='Digite aqui'
                />
              </StyledFormGroup>
              <StyledFormGroup>
                <label htmlFor='weight'>Peso</label>
                <input
                  type='number'
                  step='0.01'
                  id='weight'
                  name='weight'
                  value={form.weight}
                  onChange={handleChange}
                  placeholder='Digite aqui'
                  min='0'
                />
              </StyledFormGroup>
              <StyledFormGroup>
                <label htmlFor='location'>Local</label>
                <select
                  id='location'
                  name='location'
                  value={form.location}
                  onChange={handleChange}
                >
                  <option value=''>Selecione</option>
                  <option value='local1'>Local 1</option>
                  <option value='local2'>Local 2</option>
                </select>
              </StyledFormGroup>
            </FormGrid>
          </StyledCard>

          <StyledCard>
            <CardTitle>Operação</CardTitle>
            <FormGrid cols={2}>
              <StyledFormGroup>
                <label htmlFor='costPerHour'>Custo/Hora</label>
                <input
                  type='number'
                  step='0.01'
                  id='costPerHour'
                  name='costPerHour'
                  value={form.costPerHour}
                  onChange={handleChange}
                  placeholder='Digite aqui'
                  min='0'
                />
              </StyledFormGroup>
              <StyledFormGroup>
                <label htmlFor='capacity'>Capacidade</label>
                <input
                  type='text'
                  id='capacity'
                  name='capacity'
                  value={form.capacity}
                  onChange={handleChange}
                  placeholder='Digite aqui'
                />
              </StyledFormGroup>
            </FormGrid>
          </StyledCard>

          <StyledCard>
            <CardTitle>Prestador de Serviço</CardTitle>
            <StyledFormGroup>
              <UserSelect<UserItemType>
                key={userSelectKey}
                label=''
                apiUrl={`${process.env.REACT_APP_GATEWAY_BASE_URL}/backend/user/findAll`}
                displayField='name'
                value={null}
                onChange={handleAddServiceProvider}
                permission="production"
              />
              <DropdownHeaderSelectedItems>
                {form.selectedServiceProviders.map((provider) => (
                  <DropdownSelectedItemTag key={provider.id}>
                    {provider.name}
                    <button
                      type='button'
                      onClick={(e) => {
                        e.stopPropagation()
                        handleRemoveServiceProvider(provider.id)
                      }}
                    >
                      x
                    </button>
                  </DropdownSelectedItemTag>
                ))}
              </DropdownHeaderSelectedItems>
            </StyledFormGroup>
          </StyledCard>

          <StyledCard>
            <StyledCardHeader>
              <CardTitle isMaintenance>Manutenção periódica</CardTitle>
              <AddMaintenanceButton type='button' onClick={addMaintenanceItem}>
                <img src={plus} alt='Adicionar' />
                Adicionar manutenção
              </AddMaintenanceButton>
            </StyledCardHeader>

            {maintenanceSchedule.map((item) => (
              <MaintenanceItemFields
                key={item.id}
                item={item}
                onMaintenanceChange={handleMaintenanceChange}
                onRemove={removeMaintenanceItem}
              />
            ))}
          </StyledCard>

          <ActionButtons>
            <CancelButton
              type='button'
              onClick={() => navigate('/panel/equipment')}
            >
              Cancelar
            </CancelButton>
            <SaveButton type='submit'>
              <img src={save} alt='Salvar' />
              Salvar máquina
            </SaveButton>
          </ActionButtons>
        </form>
      </MainContainer>
    </>
  )
}

export default EditMachine
